import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import { helpers } from 'styles'

type Props = {
	wide?: boolean
}

export const CenterContent = styled.div<Props>`
	margin: 10vh auto 0;
	max-width: 760px;
	padding: ${helpers.spacing.large};
	height: 100%;

	${mobileMediaQuery(css`
		margin-top: 0;
		padding: ${helpers.spacing.medium};
	`)}
`
